import React from "react";
import { useI18n } from "../hooks/useI18n.js";

/**
 * Compact FR | EN language switcher per language-switcher-contract.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.testId]
 */
export function LanguageSwitcher({ className = "", testId = "coquille-lang-switcher" }) {
  const { lang, setLang } = useI18n();

  return (
    <span className={className} data-testid={testId} role="group" aria-label="Language">
      <button
        type="button"
        onClick={() => setLang("fr")}
        aria-current={lang === "fr" ? "true" : undefined}
        style={{
          fontWeight: lang === "fr" ? "bold" : "normal",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "0 4px",
        }}
      >
        FR
      </button>
      <span aria-hidden="true"> | </span>
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-current={lang === "en" ? "true" : undefined}
        style={{
          fontWeight: lang === "en" ? "bold" : "normal",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "0 4px",
        }}
      >
        EN
      </button>
    </span>
  );
}
